import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Text color of the *unselected* (tertiary) pills. Separate from the selected
// pill color so a readable resting-state color survives a high-contrast select.
export default class FilterToolbarUnselectedFontColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Unselected Pill Text Color",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      colorContext: "Fonts",
    },
  };

  static defaultValue = {
    value: "standard",
    source: "theme.font",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (typeof themeMode === "object") {
      themeMode = "inherit";
    }

    if (configValue.source && configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue?.value;
  }
}
